export default {
  getMisData: `${process.env.REACT_APP_GIS_API_URL}/api/BufferMisData/Getmisdataforbuffer`,
  gisLogin: `${process.env.REACT_APP_GIS_API_URL}/api/Auth/login`,
  gisNewUser: `${process.env.REACT_APP_GIS_API_URL}/api/User/register`,
  createUserRole: `${process.env.REACT_APP_GIS_API_URL}/api/User/CreateUserRole`,
  getDisUlb: `${process.env.REACT_APP_GIS_API_URL}/api/Administrative/Get_District_Ulb_Ward`,
  getDepartment: `${process.env.REACT_APP_GIS_API_URL}/api/Administrative/Get_Department_Designation`,
  GetUserRoleDetails: `${process.env.REACT_APP_GIS_API_URL}/api/User/GetUserRoleDetails`,
  createUserPermission: `${process.env.REACT_APP_GIS_API_URL}/api/Administrative/CreateUserPermission`,
  getUserDetails: `${process.env.REACT_APP_GIS_API_URL}/api/User/GetUserDetails`,
  logCreate: `${process.env.REACT_APP_GIS_API_URL}/api/Auth/CreateLog`,
  getModuleAccess: `${process.env.REACT_APP_GIS_API_URL}/api/Auth/GetLogs`,
  getUserPermission: `${process.env.REACT_APP_GIS_API_URL}/api/Administrative/GetUsersRolePermission`,
  getUserPermissionEdit: `${process.env.REACT_APP_GIS_API_URL}/api/Administrative/EditUserPermission`,
  searchUsers: `${process.env.REACT_APP_GIS_API_URL}/api/User/SearchUserByValue`,
  editUser: `${process.env.REACT_APP_GIS_API_URL}/api/User/EditUserDetails`,
  utilityDashboard: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard`,
  // getuploadedULB: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/GetuploadedULB`,
  ENPPropertyDetails: `${process.env.REACT_APP_GIS_API_URL}/api/ENP/ENPPropertyDetails`,
  TotalULB: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/TotalULB`,
  TotalWard: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/TotalWard`,
  TotalProperties: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/TotalProperties`,
  GetuploadedULB: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/GetuploadedULB`,
  GetuploadedWard: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/GetuploadedWard`,
  WaterSupplyULB: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/WaterSupplyULB`,
  intakeWall: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/Intakewell`,
  rowWaterPm: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/RWPM`,
  waterTreatmentPlant: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/WTP`,
  clearWaterPumpingMain: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/CWPM`,
  totalOverHeadTank: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/OHT`,
  distributionPipeline: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/DistributionPipeline`,
  waterJunction: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/Junction`,
  sewerNetworkulb: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/SewerNetworkulb`,
  sewerNetwork: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/SewerNetwork`,
  sewerTreatmentPlant: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/STP`,
  seweragePumpingStation: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/MPS`,
  intermediatePumpingStation: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/IPS`,
  totalManholes: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/ManHole`,
  population: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/Population`,
  GetUserVisitCount: `${process.env.REACT_APP_GIS_API_URL}/api/Auth/GetUserVisitCount`,
  roadNetWorklength: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/RoadNetWorklength`,
  roadNetWork: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/RoadNetWork`,
  RoadNetWorkULB: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/RoadNetWorkULB`,

  totalRiver: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/River`,
  waterbody: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/Waterbody`,
  totalParks: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/Parks`,
  forestArea: `${process.env.REACT_APP_GIS_API_URL}/api/UtilityDashboard/Forest`,

  GetLogsByUser: `${process.env.REACT_APP_GIS_API_URL}/api/Auth/GetLogsByUser`,
  DeleteUserDetails: `${process.env.REACT_APP_GIS_API_URL}/api/User/DeleteUserDetails`,
  DeleteUserRole: `${process.env.REACT_APP_GIS_API_URL}/api/User/DeleteUserRole`,
  EditUserRole: `${process.env.REACT_APP_GIS_API_URL}/api/User/EditUserRole`,

}